// extracted by mini-css-extract-plugin
export default {"container":"Wrapper_container__EcUng","title":"Wrapper_title__aXFiq"};